import React, { useState } from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import {
  Avatar,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Paper,
  Typography,
  IconButton,
} from "@material-ui/core";
import { TextInput } from "./textInput.js";
import { MessageLeft, MessageRight } from "./message";
import { GroupRounded } from "@material-ui/icons";
import Modal from "./ViewListModal/modal";

import moment from "moment";

const useStyles = makeStyles((theme) =>
  createStyles({
    paper: {
      width: "calc(100% - 820px)",
      height: "calc(100% - 159px)",
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      position: "absolute",
      top: "150px",
      right: "410px",
      [theme.breakpoints.down("md")]: {
        top: "750px",
        height: "500px",
        left: "5px",
        width: "calc(100vw - 100px)",
      },
    },
    paper2: {
      width: "80vw",
      maxWidth: "500px",
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      position: "relative",
    },
    container: {
      //   width: "100vw",
      //   height: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    messagesBody: {
      width: "calc( 100% - 20px )",
      margin: 10,
      overflowY: "scroll",
      height: "calc( 100% - 220px )",
      padding: "10px",
    },
    objectFit: {
      objectFit: "contain",
    },
  })
);

export default function Chatbox(props) {
  const classes = useStyles();
  // const scrollToBottom = useScrollToBottom()
  // const [sticky] = useSticky()

  const value = JSON.parse(localStorage.getItem("SavedLoggedInData"));
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div style={{ margin: "10px" }} className={classes.container}>
      <Modal
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        clickedTab={props.clickedTab}
        // startupNamesList={startupData}
        clickedGroupName={props.clickedGroupName}
        setclickedGroupName={props.setclickedGroupName}
        // mentorNamesList={mentorData}
        participants={props.activeChat?.participants}
        groupName={
          props?.activeChat?.bpartyId === value?.id
            ? props?.activeChat?.apartyName
            : props?.activeChat?.bpartyName
        }
      />
      <Paper className={classes.paper} zDepth={2}>
        <Paper
          style={{
            width: "100%",
            backgroundColor: "#b499c7",
            color: "white",
            borderRadius: 0,
          }}
        >
          <ListItem
            alignItems="center"
            style={{ width: "100%", height: "71px" }}
          >
            <ListItemAvatar>
              <Avatar
                alt={"somgthing"}
                classes={{
                  img: classes.objectFit,
                }}
                src={
                  props.activeChat?.image ||
                  props.activeChat?.bpartyId === value?.id
                    ? props.activeChat?.apartyImage
                    : props.activeChat?.bpartyImage
                }
              />
            </ListItemAvatar>
            <ListItemText
              primary={
                <>
                  <Typography
                    noWrap
                    style={{
                      fontSize: "18px",
                      fontFamily: "Montserrat",
                      fontWeight: "bold",
                      color: "white",
                    }}
                  >
                    {props.clickedTab === false &&
                    props.clickedGroupName === true &&
                    props.clickedIndiName === false &&
                    props.activeChat?.bpartyId === value?.id
                      ? props.activeChat?.apartyName
                      : props.activeChat?.bpartyName
                      ? props.activeChat?.bpartyId === value?.id
                        ? props.activeChat?.apartyName
                        : props.activeChat?.bpartyName
                      : props.activeChat?.groupSubject}

                    {/* {props.clickedTab === false &&
                    props.clickedGroupName === true &&
                    props.clickedIndiName === false
                      ? props.activeChat?.bpartyId === value?.id
                        ? props.activeChat?.apartyName
                        : props.activeChat?.bpartyName
                      : props.clickedTab === true &&
                        props.clickedGroupName === false &&
                        props.clickedIndiName === true
                      ? props.activeChat?.groupSubject
                      : ""} */}
                    {/* {props.clickedTab === false &&
                    props.clickedGroupName === true &&
                    props.clickedIndiName === false ? (
                      <IconButton onClick={() => setModalOpen(true)}>
                        <GroupRounded style={{ color: "white" }} />
                      </IconButton>
                    ) : props.clickedTab === true &&
                      props.clickedGroupName === false &&
                      props.clickedIndiName === true ? (
                      <IconButton onClick={() => setModalOpen(true)}>
                        <GroupRounded style={{ color: "white" }} />
                      </IconButton>
                    ) : (
                      ""
                    )} */}

                    {props.activeChat?.participants &&
                      props.activeChat?.participants.length > 0 && (
                        <IconButton onClick={() => setModalOpen(true)}>
                          <GroupRounded style={{ color: "white" }} />
                        </IconButton>
                      )}
                    {/* <IconButton onClick={() => setModalOpen(true)}>
                      <GroupRounded style={{ color: "white" }} />
                    </IconButton> */}
                  </Typography>
                </>
              }
            />
          </ListItem>
        </Paper>
        <Paper id="style-1" className={classes.messagesBody}>
          {props.chatData?.map((chat) => {
            if (chat?.message?.commentedByUserRole === value?.role) {
              return (
                <MessageRight
                  messagedelete={chat?.deleted}
                  message={chat?.message?.text}
                  messageId={chat?.id}
                  image={chat?.message?.filePath}
                  avatarDisp={true}
                  timestamp={moment(chat?.message?.createdDate).format(
                    "DD-MM-YYYY hh:mm a"
                  )}
                />
              );
            } else {
              return (
                <MessageLeft
                  messagedelete={chat?.deleted}
                  message={chat?.message?.text}
                  image={chat?.message?.filePath}
                  avatarDisp={true}
                  timestamp={moment(chat?.message?.createdDate).format(
                    "DD-MM-YYYY hh:mm a"
                  )}
                />
              );
            }
          })}
          {props.anchorElement}
        </Paper>
        {Boolean(props.activeChat) && <TextInput {...props} />}
      </Paper>
    </div>
  );
}
